import React from 'react';
const SvgPdfNative = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path fill="#FF1B0F" d="M3 1v30h26V8h-7V1z" />
        <path fill="#FFF" d="M4 2v20h24V8h-6V2z" />
        <path fill="#1B3F63" opacity={0.3} d="M29 15l-7-7h7z" />
        <path fill="#AF3428" d="M22 1l7 7h-7z" />
        <text
          fill="#FFF"
          fontFamily="Helvetica-Bold, Helvetica"
          fontSize={7}
          fontWeight="bold"
          transform="translate(3 1)"
        >
          <tspan x={6.578} y={28}>
            {'PDF'}
          </tspan>
        </text>
        <path
          d="M24.465 15.39c-.105.066-.405.106-.595.106-.62 0-1.38-.285-2.455-.745.415-.03.79-.045 1.13-.045.62 0 .8 0 1.41.155.605.15.61.465.51.53zm-10.754.096a44 44 0 00.735-1.34c.61-1.155 1-2.065 1.285-2.81a9.35 9.35 0 002.125 2.64c.105.09.215.175.335.265-1.705.34-3.18.75-4.48 1.245zm1.99-10.944c.34 0 .535.853.55 1.658.015.8-.17 1.36-.405 1.78-.195-.62-.285-1.59-.285-2.225 0 0-.015-1.213.14-1.213zM9.03 19.9c.196-.525.956-1.565 2.08-2.49.07-.055.245-.22.405-.37-1.174 1.88-1.964 2.625-2.484 2.86zm15.759-5.614c-.34-.335-1.1-.51-2.25-.525-.78-.01-1.715.06-2.705.195-.44-.255-.894-.53-1.254-.865-.96-.9-1.76-2.145-2.26-3.515.03-.13.06-.24.085-.355 0 0 .54-3.074.395-4.114a1.112 1.112 0 00-.07-.295l-.045-.125c-.145-.338-.435-.698-.89-.679L15.53 4h-.005c-.505 0-.92.258-1.025.642-.33 1.215.01 3.025.625 5.37l-.16.384c-.44 1.07-.99 2.15-1.475 3.1l-.065.125c-.51 1-.975 1.85-1.395 2.57l-.435.23c-.03.02-.774.41-.95.514-1.48.885-2.463 1.89-2.626 2.69-.052.25-.013.575.25.73l.42.21c.182.09.377.135.572.135 1.055 0 2.28-1.31 3.964-4.254a39.43 39.43 0 016.115-1.455c1.48.835 3.3 1.415 4.449 1.415.205 0 .38-.02.525-.06a.864.864 0 00.52-.355c.22-.335.27-.795.205-1.27-.015-.14-.13-.315-.25-.435z"
          fill="#FF1B0F"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
});
export default SvgPdfNative;
SvgPdfNative.iconName = 'pdf-native';
SvgPdfNative.displayName = 'SvgPdfNative';
